import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { TealiumUtagService } from './tealium/utag.service';

@Component({
  selector: 'app-root',
  providers: [TealiumUtagService],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  public baseUrl = '';
  public searchUrl = null;

  constructor(
    private router: Router,
    private tealium: TealiumUtagService
    ) {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        const ua = navigator.userAgent;
      }
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.baseUrl = this.getUrlWithoutFragments();
    });
  }

  getUrlWithoutFragments() {
    let urlTree = this.router.parseUrl(this.router.url);
    urlTree.fragment = null;
    const url = urlTree.toString()
    return url
  }

  onActivate(event) {
    window.scroll(0,0);
  }

  ngOnInit() {
    $(document).ready(function () {
      $(document).foundation();
      $('body').on( 'click', '.contactRDVCamion', function (e) {
        e.preventDefault();
        const link = $(this).attr('href');
        window.location.replace(link);
      });
    });
  }

  public focusFunction(element)
  {
    $("#"+element).addClass('evitement_position');
    $("#"+element).removeClass('evitement');
    $("ul#evitement").removeClass('visually_hidden');
    $("ul#evitement").addClass('visually_hidden_position');
  }

  public focusOutFunction(element)
  {
    $("#"+element).removeClass('evitement_position');
    $("#"+element).addClass('evitement');
    $("ul#evitement").addClass('visually_hidden');
    $("ul#evitement").removeClass('visually_hidden_position');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts